import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActionList } from '../action-list';

@Component({
  template: `
    <h2 mat-dialog-title>{{ 'ACTION_LISTS.DELETE_ACTION_LIST_DIALOG.TITLE' | translate }}</h2>
    <mat-dialog-content>
      <p [innerHtml]="'ACTION_LISTS.DELETE_ACTION_LIST_DIALOG.ARE_YOU_SURE' | translate: { name: actionList.name }"></p>
      <p>{{ 'ACTION_LISTS.DELETE_ACTION_LIST_DIALOG.DELETING_A_LIST_IS_PERMANENT' | translate }}</p>
      <p>{{ 'ACTION_LISTS.DELETE_ACTION_LIST_DIALOG.NO_ACCOUNTS_ARE_DELETED' | translate }}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="dialogRef.close(true)">
        {{ 'COMMON.ACTION_LABELS.DELETE' | translate }}
      </button>
      <button mat-button matDialogClose tabindex="-1" class="close-button">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss', './action-list-actions.component.scss'],
  standalone: false,
})
export class DeleteListDialogComponent {
  @Input() actionList: ActionList;

  constructor(public dialogRef: MatDialogRef<DeleteListDialogComponent>) {}
}
